import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh' }}>
      <div className="luxury-container" style={{ padding: '60px 40px' }}>
        <button 
          onClick={() => navigate('/')}
          className="btn-secondary"
          style={{ marginBottom: '40px', display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <ArrowLeft size={16} />
          Back to Home
        </button>

        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 className="heading-1" style={{ marginBottom: '16px' }}>Privacy Policy</h1>
          <p className="body-small" style={{ color: 'var(--text-light)', marginBottom: '40px' }}>Last Updated: January 2025</p>

          <div className="body-regular" style={{ lineHeight: '1.8' }}>
            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>1. Information We Collect</h2>
              <p style={{ marginBottom: '16px' }}>Enliven Elite Tax Pro collects information that you provide directly to us, including:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>Name and contact information (email, phone number)</li>
                <li style={{ marginBottom: '8px' }}>Tax-related documents and financial information</li>
                <li style={{ marginBottom: '8px' }}>Appointment details and consultation notes</li>
                <li style={{ marginBottom: '8px' }}>Communication preferences</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>2. How We Use Your Information</h2>
              <p style={{ marginBottom: '16px' }}>We use the information we collect to:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>Provide professional tax preparation services</li>
                <li style={{ marginBottom: '8px' }}>Communicate with you about your tax returns and appointments</li>
                <li style={{ marginBottom: '8px' }}>Send you tax tips, reminders, and updates (if subscribed)</li>
                <li style={{ marginBottom: '8px' }}>Comply with legal and regulatory requirements</li>
                <li style={{ marginBottom: '8px' }}>Improve our services and customer experience</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>3. Information Security</h2>
              <p style={{ marginBottom: '16px' }}>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Your tax documents and financial information are stored securely and encrypted.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>4. Information Sharing</h2>
              <p style={{ marginBottom: '16px' }}>We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>With your explicit consent</li>
                <li style={{ marginBottom: '8px' }}>To comply with legal obligations or court orders</li>
                <li style={{ marginBottom: '8px' }}>With professional service providers who assist in tax preparation (under strict confidentiality agreements)</li>
                <li style={{ marginBottom: '8px' }}>To protect our rights and prevent fraud</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>5. Your Rights</h2>
              <p style={{ marginBottom: '16px' }}>You have the right to:</p>
              <ul style={{ marginLeft: '24px', marginBottom: '16px' }}>
                <li style={{ marginBottom: '8px' }}>Access your personal information</li>
                <li style={{ marginBottom: '8px' }}>Request corrections to your data</li>
                <li style={{ marginBottom: '8px' }}>Request deletion of your information (subject to legal retention requirements)</li>
                <li style={{ marginBottom: '8px' }}>Unsubscribe from marketing communications</li>
                <li style={{ marginBottom: '8px' }}>Opt-out of data collection (may limit service availability)</li>
              </ul>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>6. Cookies and Tracking</h2>
              <p style={{ marginBottom: '16px' }}>Our website uses cookies to improve your browsing experience and analyze site traffic. You can control cookie settings through your browser preferences.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>7. Data Retention</h2>
              <p style={{ marginBottom: '16px' }}>We retain your information for as long as necessary to provide services and comply with legal obligations. Tax records are retained in accordance with IRS requirements (typically 7 years).</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>8. Children's Privacy</h2>
              <p style={{ marginBottom: '16px' }}>Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>9. Changes to This Policy</h2>
              <p style={{ marginBottom: '16px' }}>We may update this Privacy Policy periodically. We will notify you of any material changes by posting the new policy on our website and updating the "Last Updated" date.</p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>10. Contact Us</h2>
              <p style={{ marginBottom: '16px' }}>If you have questions about this Privacy Policy or our data practices, please contact us:</p>
              <p style={{ marginBottom: '8px' }}><strong>Enliven Elite Tax Pro</strong></p>
              <p style={{ marginBottom: '8px' }}>Phone: 800-426-0441</p>
              <p style={{ marginBottom: '8px' }}>Email: taxprep@enlivenelite.tax</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;